import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AppMenuTabs } from '../components/MenuTabs/userTabsInterface';
import User from '../models/User';

const usePortfolioName = () => {
    const { t } = useTranslation();
    const menuTabs = useSelector<any, AppMenuTabs>(state => state.menuTabs);
    const user = useSelector<any, User>(state => state.user);
    const portfolioSelectedTab = menuTabs.portfolioSelectedTab;

    const getPortfolioName = () => {
        if (portfolioSelectedTab.internalId === '0_global_bid') {
            return t(portfolioSelectedTab.title);
        }

        return portfolioSelectedTab.assignedToMe ? user.name : portfolioSelectedTab.title;
    };

    return getPortfolioName();
};

export default usePortfolioName;